export const getDescriptionContent = (description) => {
    if (description?.content?.length > 0) {
        // have some content
        if (description?.content[0]?.content?.length > 0) {
            return description?.content[0]?.content[0].text;
        }
    }
    return 'No description specified';
};

export const getSubtasksReduced = (subtasks) => {
    if (Array.isArray(subtasks)) {
        return subtasks.map((entry) => { return entry?.fields?.summary; }).join(', ');
    }
    return '';
};




// WEBPACK FOOTER //
// ./services/jiraService.js